module.exports = __webpack_public_path__ + "img/Corinth_Periander_Vaticano.1de434d1.png";